const DEFAULT_RACE_CONFIGURATION = {
  maxChoices: 1,
  retention: false,
  rankedChoice: {
    enabled: false,
    maxChoices: 1,
  },
};

export const getRaceConfigurationForOffice = office => {
  const officeConfiguration = office?.defaultRaceConfiguration;

  return {
    maxChoices: officeConfiguration?.maxChoices ?? DEFAULT_RACE_CONFIGURATION.maxChoices,
    retention: officeConfiguration?.retention ?? DEFAULT_RACE_CONFIGURATION.retention,
    rankedChoice: {
      enabled: officeConfiguration?.rankedChoice?.enabled ?? DEFAULT_RACE_CONFIGURATION.rankedChoice.enabled,
      maxChoices: officeConfiguration?.rankedChoice?.maxChoices ?? DEFAULT_RACE_CONFIGURATION.rankedChoice.maxChoices,
    },
  };
};
